import styled from 'styled-components';
import { PaginatorStyled } from '../PaginatorStyled';
import { rem } from 'polished';

export const PaginatorStyledAC = styled(PaginatorStyled)`
    .pagination {
        margin-bottom: ${rem('50px')};
        li {
            a {
                color: ${({ theme }) => theme.colors.black};
                text-decoration: none;
                background-color: transparent;
                border: 0;
                padding: ${rem('6px')} ${rem('15px')};
                &:hover {
                    color: ${({ theme }) => theme.colors.blue2};
                }
            }

            &.active a {
                color: ${({ theme }) => theme.colors.blue2};
                background-color: transparent;
            }
        }
    }
`;
